/**
 * テナントライセンスキー定数
 * バックエンド (strix_db/types/enums.py) の LicenseKey enum と同期
 */
export const LICENSE_KEY = {
  EMAIL_SEARCH: "EMAIL_SEARCH",
  BULK_DELIVERY: "BULK_DELIVERY",
  MATCHING: "MATCHING",
  AI_HELPER: "AI_HELPER",
} as const;

export type LicenseKey = (typeof LICENSE_KEY)[keyof typeof LICENSE_KEY];

/** ライセンスキーの日本語ラベル */
export const LICENSE_LABELS: Record<LicenseKey, string> = {
  EMAIL_SEARCH: "メール検索",
  BULK_DELIVERY: "一斉配信",
  MATCHING: "マッチング",
  AI_HELPER: "AIヘルパー",
};

/**
 * ユーザーの現在のテナントが指定ライセンスを持っているかを判定
 * @param {string[] | undefined} licenses - ライセンスキー配列
 * @param {LicenseKey} key - チェックするライセンスキー
 * @return {boolean} ライセンスを持っている場合true
 */
export const hasLicense = (
  licenses: string[] | undefined,
  key: LicenseKey,
): boolean => {
  if (!licenses || licenses.length === 0) return false;
  return licenses.includes(key);
};
